const API = {
  register: "/api/register",
  login: "/api/login",
  adminLogin: "/api/admin/login",
  businessUpdate: "/api/businesses",
  getBusiness: "/api/businesses/me",
  getBusinesses: "/api/businesses",

  venueSave: "/api/venues",
  getVenue: "/api/venues/me",
  venueImages: "/api/venues/images",
  imagesUpload: "/api/images/upload",
  getImages: "/api/images",
  enquiryPost: "/api/enquiries",
  enquiryUpdate: "/api/enquiries",
  enquiryView: "/api/enquiries/view",
  getEnquiries: "/api/enquiries",
  reviewPost: "/api/reviews",
  getUsers: "/api/users",

  vendorPost: "/api/vendors",
  getVendors: "/api/vendors",
  getVendorProfile: "/api/vendors/me",
  postUsers: "/api/users",
  sendMail: "/api/mail/send",
  resetPassword: "/api/reset-password",
  realWeddingsPost: "/api/realweddings",
  getRealWeddings: "/api/realweddings",
  getRealWedding: (id) => `/api/realweddings/${id}`,
  realWeddingUpdate: (id) => `/api/realweddings`,
};
export default API;
